module.exports = __webpack_public_path__ + "img/document.02401858.svg";